import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import ExperienceCard from "../components/ExperienceCard";
import api from "../lib/api";
import { Loader2, Search } from "lucide-react";
import { Input } from "../components/ui/input";

export default function Experiences() {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/experiences").then((r) => setExperiences(r.data)).finally(() => setLoading(false));
  }, []);

  const upcoming = experiences.filter((e) => e.coming_soon || new Date(e.date) >= new Date());
  const cats = ["All", ...Array.from(new Set(upcoming.map((e) => e.category)))];
  const filtered = upcoming.filter((e) =>
    (cat === "All" || e.category === cat) &&
    (e.title.toLowerCase().includes(q.toLowerCase()) || (e.short_description || "").toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <span className="eyebrow text-exploration">H.E.A. Experiences</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">The World Is Their Classroom.</h1>
          <p className="mt-4 max-w-xl text-white/70">Browse upcoming field experiences, workshops and career explorations. Register in minutes.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="relative w-full max-w-md">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            <Input data-testid="experiences-search" value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="Search experiences" className="h-12 pl-10" />
          </div>
          <div className="flex flex-wrap gap-2">
            {cats.map((c) => (
              <button key={c} data-testid={`experiences-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`rounded-full border px-4 py-2 font-display text-sm font-semibold transition-colors ${cat === c ? "border-brandblue bg-brandblue text-white" : "border-slate-200 bg-white text-navy hover:border-brandblue"}`}>
                {c}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-brandblue" /></div>
        ) : filtered.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-300 py-20 text-center text-slateBrand">No experiences match your search.</div>
        ) : (
          <div className="grid gap-7 md:grid-cols-2 lg:grid-cols-3">
            {filtered.map((e) => <ExperienceCard key={e.id} exp={e} />)}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
